define('salesInboxRoutingRulesView',[
  'module',
  'app',
  'backbone',
  'underscore',
  'jquery',
  'marionette',
  'entities/sales_inbox',
  'entities/admin/user_groups'
], function (Module, App, Backbone, _, $, Marionette) {
  'use strict';

  var CATEGORIES = ['', 'SALES', 'DESIGN', 'INVOICING', 'RECLAMATION', 'TRACKING', 'NOT_ACTIONABLE'];
  var POTENTIALS = ['', 'SMALL_ORDER_VALUE', 'MEDIUM_ORDER_VALUE', 'BIG_ORDER_VALUE'];
  var LOCALES = ['', 'de', 'fr', 'nl', 'it', 'es', 'da', 'en'];
  var CASES_BY_CATEGORY = {
    SALES:          ['PRICE_NEGOTIATION', 'OFFER_DECLINED', 'EXPRESS_DELIVERY', 'STOCKS', 'PURCHASE_ORDER', 'REORDER', 'READY_TO_ORDER', 'DELIVERY_TIME', 'SAMPLE', 'QUANTITY', 'OFFER_REQUEST', 'CHANGE', 'UNFINISHED_ORDER', 'UNDER_REVIEW'],
    DESIGN:         ['ASK_FOR_MODIFICATION', 'LOGO_NOT_PRINTABLE', 'NO_LOGO_SENT'],
    INVOICING:      ['ASK_FOR_INVOICE', 'PAY_AFTER_DELIVERY', 'CHANGE_DATA', 'ASK_FOR_RIB'],
    RECLAMATION:    ['PRINTING_ISSUE', 'BROKEN_GOODS', 'MISSING_GOODS'],
    TRACKING:       ['WHEN_WILL_ARRIVE', 'DID_NOT_ARRIVE', 'PROBLEM'],
    NOT_ACTIONABLE: ['OUT_OF_OFFICE', 'EMAIL_NOT_DELIVERED', 'CARRIER_SURVEY', 'VENDOR_SOLICITATION']
  };

  Module.exports = Marionette.LayoutView.extend({
    className: 'sales-inbox-routing-rules-view',
    template: _.template(
      '<div class="toolbar">' +
      '  <h3>Sales Inbox — Routing Rules</h3>' +
      '  <button class="btn-add">+ Add rule</button>' +
      '</div>' +
      '<table class="rules-table">' +
      '  <thead><tr>' +
      '    <th>Category</th><th>Case</th><th>Potential</th><th>Locale</th>' +
      '    <th>Target team</th><th>Priority</th><th>Enabled</th><th></th>' +
      '  </tr></thead>' +
      '  <tbody></tbody>' +
      '</table>'
    ),

    regions: { body: 'tbody' },

    events: {
      'click .btn-add': 'onAdd'
    },

    onBeforeShow: function () {
      this.load();
    },

    load: function () {
      var self = this;
      var groupsUrl = App.request('userGroups:get-url', { first: 0, pageSize: 200 });
      var groupsRequest = groupsUrl ?
        $.ajax({ type: 'GET', url: groupsUrl }) :
        $.Deferred().resolve([]);
      $.when(
        $.ajax({ type: 'GET', url: App.request('salesInbox:routing-rules:list-url', { first: 0, pageSize: 500 }) }),
        groupsRequest
      ).done(function (rulesResp, groupsResp) {
        self.rules = (rulesResp && rulesResp[0]) || [];
        self.groups = (groupsResp && groupsResp[0]) || [];
        self.renderRows();
      });
    },

    renderRows: function () {
      var self = this;
      var $tbody = this.$('tbody').empty();
      _.each(this.rules, function (rule) {
        $tbody.append(self.renderRow(rule));
      });
    },

    renderRow: function (rule) {
      var self = this;
      var tr = $('<tr></tr>');
      tr.append('<td>' + (rule.category || '—') + '</td>');
      tr.append('<td>' + (rule.emailCase || '—') + '</td>');
      tr.append('<td>' + (rule.potential || '—') + '</td>');

      var localeTd = $('<td></td>');
      var localeSel = self.buildLocaleSelect(rule.locale);
      localeSel.on('change', function () {
        self.updateRuleField(rule, tr, { locale: localeSel.val() || null });
      });
      localeTd.append(localeSel);
      tr.append(localeTd);

      var teamTd = $('<td></td>');
      var teamSel = self.buildTeamSelect(rule);
      teamSel.on('change', function () {
        self.updateRuleField(rule, tr, { targetGroupSecId: teamSel.val() || null });
      });
      teamTd.append(teamSel);
      tr.append(teamTd);

      var priorityTd = $('<td></td>');
      var priorityInput = $('<input type="number" class="priority-input">').val(rule.priority || 0);
      priorityInput.on('change', function () {
        self.updateRuleField(rule, tr, { priority: parseInt(priorityInput.val() || '0', 10) });
      });
      priorityTd.append(priorityInput);
      tr.append(priorityTd);

      tr.append('<td>' + (rule.enabled ? 'yes' : 'no') + '</td>');
      var actions = $('<td></td>');
      var edit = $('<button class="btn-edit">Edit</button>');
      var del  = $('<button class="btn-del">Delete</button>');
      edit.on('click', function () { self.openEditor(rule); });
      del.on('click', function () {
        if (!window.confirm('Delete this routing rule?')) return;
        App.request('salesInbox:routing-rules:delete', rule.secId).done(function () { self.load(); });
      });
      actions.append(edit).append(' ').append(del);
      tr.append(actions);
      return tr;
    },

    buildLocaleSelect: function (current) {
      var sel = $('<select class="locale-select"></select>');
      _.each(LOCALES, function (loc) {
        var o = $('<option></option>').val(loc).text(loc === '' ? '(any)' : loc.toUpperCase());
        if ((current || '') === loc) o.prop('selected', true);
        sel.append(o);
      });
      return sel;
    },

    buildTeamSelect: function (rule) {
      var sel = $('<select class="team-select"></select>');
      sel.append($('<option></option>').val('').text('(none)'));
      _.each(this.groups, function (g) {
        var o = $('<option></option>').val(g.secId).text(g.name);
        if (rule.targetGroupSecId === g.secId ||
            (!rule.targetGroupSecId && rule.targetGroupName && rule.targetGroupName === g.name)) {
          o.prop('selected', true);
        }
        sel.append(o);
      });
      return sel;
    },

    updateRuleField: function (rule, tr, partial) {
      var self = this;
      var payload = {
        category: rule.category || null,
        emailCase: rule.emailCase || null,
        potential: rule.potential || null,
        locale: rule.locale || null,
        targetGroupSecId: rule.targetGroupSecId || null,
        priority: rule.priority || 0,
        enabled: rule.enabled !== false
      };
      _.extend(payload, partial);
      tr.addClass('saving');
      App.request('salesInbox:routing-rules:update', rule.secId, payload).done(function (data) {
        _.extend(rule, payload);
        if (data && data.targetGroupName !== undefined) {
          rule.targetGroupName = data.targetGroupName;
        } else if ('targetGroupSecId' in partial) {
          var g = _.findWhere(self.groups, { secId: partial.targetGroupSecId });
          rule.targetGroupName = g ? g.name : null;
        }
        tr.removeClass('saving');
      }).fail(function (xhr) {
        tr.removeClass('saving');
        alert('Update failed: ' + (xhr && xhr.status));
        self.load();
      });
    },

    onAdd: function () {
      this.openEditor(null);
    },

    openEditor: function (rule) {
      var self = this;
      var isNew = !rule;
      rule = rule || { enabled: true, priority: 0 };

      var overlay = $('<div class="rule-editor-overlay"></div>');
      var panel = $('<div class="rule-editor"></div>');
      overlay.append(panel);

      panel.append('<h4>' + (isNew ? 'Add' : 'Edit') + ' routing rule</h4>');

      function buildSelect(key, options, current, withLabels) {
        var sel = $('<select></select>').attr('data-key', key);
        _.each(options, function (opt) {
          var o = $('<option></option>').val(opt).text(opt === '' ? '(any)' : (withLabels ? opt : opt));
          if ((current || '') === opt) o.prop('selected', true);
          sel.append(o);
        });
        return sel;
      }

      var categorySel = buildSelect('category', CATEGORIES, rule.category || '');
      var caseSel = $('<select data-key="emailCase"></select>');
      function refreshCases() {
        var cat = categorySel.val();
        caseSel.empty();
        caseSel.append('<option value="">(any)</option>');
        _.each(CASES_BY_CATEGORY[cat] || [], function (c) {
          var o = $('<option></option>').val(c).text(c);
          if (rule.emailCase === c) o.prop('selected', true);
          caseSel.append(o);
        });
      }
      categorySel.on('change', refreshCases);
      refreshCases();

      var potSel = buildSelect('potential', POTENTIALS, rule.potential || '');
      var localeSel = buildSelect('locale', LOCALES, rule.locale || '');

      var groupSel = $('<select data-key="targetGroupSecId"></select>');
      _.each(self.groups, function (g) {
        var o = $('<option></option>').val(g.secId).text(g.name);
        if (rule.targetGroupSecId === g.secId || (rule.targetGroupName && rule.targetGroupName === g.name)) {
          o.prop('selected', true);
        }
        groupSel.append(o);
      });

      var priorityInput = $('<input type="number" data-key="priority">').val(rule.priority || 0);
      var enabledInput = $('<input type="checkbox" data-key="enabled">').prop('checked', rule.enabled !== false);

      function row(label, field) {
        var r = $('<div class="row"></div>');
        r.append($('<label></label>').text(label));
        r.append(field);
        return r;
      }

      panel.append(row('Category', categorySel));
      panel.append(row('Case', caseSel));
      panel.append(row('Potential', potSel));
      panel.append(row('Locale', localeSel));
      panel.append(row('Target team', groupSel));
      panel.append(row('Priority', priorityInput));
      panel.append(row('Enabled', enabledInput));

      var actions = $('<div class="actions"></div>');
      var saveBtn = $('<button class="btn-save">Save</button>');
      var cancelBtn = $('<button class="btn-cancel">Cancel</button>');
      saveBtn.on('click', function () {
        var payload = {
          category: categorySel.val() || null,
          emailCase: caseSel.val() || null,
          potential: potSel.val() || null,
          locale: localeSel.val() || null,
          targetGroupSecId: groupSel.val() || null,
          priority: parseInt(priorityInput.val() || '0', 10),
          enabled: enabledInput.is(':checked')
        };
        var req = isNew ?
          App.request('salesInbox:routing-rules:create', payload) :
          App.request('salesInbox:routing-rules:update', rule.secId, payload);
        req.done(function () {
          overlay.remove();
          self.load();
        }).fail(function (xhr) {
          alert('Save failed: ' + (xhr && xhr.status));
        });
      });
      cancelBtn.on('click', function () { overlay.remove(); });
      actions.append(saveBtn).append(' ').append(cancelBtn);
      panel.append(actions);

      $('body').append(overlay);
    }
  });
});

